import { createSlice } from '@reduxjs/toolkit';

import {
	handleAsyncThunkActionState,
	initialAsyncState,
	isAsyncThunkActionWithPrefix
} from '../utils';
import { fetchCollaborators } from './thunks';

const initialState = {
	searchTerm: '',
	collaborators: [],
	collaboratorsCount: 0,
	fetchCollaborators: initialAsyncState,
	createCollaborator: initialAsyncState,
	editCollaborator: initialAsyncState,
	deleteCollaborator: initialAsyncState,
	sendCollaboratorInvitation: initialAsyncState,
	collaboratorsModalOpen: false,
	deleteCollaboratorModalOpen: false,
	selectedCollaborator: null,
	upgradeToAddUsersModalOpen: false
};

const collaboratorsSlice = createSlice({
	name: 'collaborators',
	initialState,
	reducers: {
		clearData() {
			return initialState;
		},
		setSearchTerm(state, action) {
			state.searchTerm = action.payload;
		},
		removeCollaborator(state, action) {
			state.collaborators = state.collaborators.filter(
				item => item.id !== action.payload
			);
		},
		setCreateCollaboratorModal(state, action) {
			state.collaboratorsModalOpen = action.payload;
		},
		setDeleteCollaboratorModal(state, action) {
			state.deleteCollaboratorModalOpen = action.payload;
		},
		setSelectedCollaborator(state, action) {
			state.selectedCollaborator = action.payload;
		},
		setUpgradeToAddUsersModal(state, action) {
			state.upgradeToAddUsersModalOpen = action.payload;
		}
	},
	extraReducers(builder) {
		builder.addCase(fetchCollaborators.fulfilled, (state, action) => {
			state.collaborators = action.payload;
		});
		builder.addMatcher(
			isAsyncThunkActionWithPrefix('collaborators'),
			handleAsyncThunkActionState()
		);
	}
});

export const {
	clearData,
	setSearchTerm,
	removeCollaborator,
	setCreateCollaboratorModal,
	setDeleteCollaboratorModal,
	setSelectedCollaborator,
	setUpgradeToAddUsersModal
} = collaboratorsSlice.actions;

export default collaboratorsSlice.reducer;
